module.exports = __webpack_public_path__ + "static/thaw_catalog_cover-5f466c9bd9253b41bca505b7b18b3b1f.jpg";